import { render, staticRenderFns } from "./tutorials.vue?vue&type=template&id=b21c3ce6&scoped=true&"
import script from "./tutorials.vue?vue&type=script&lang=js&"
export * from "./tutorials.vue?vue&type=script&lang=js&"
import style0 from "./tutorials.vue?vue&type=style&index=0&id=b21c3ce6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b21c3ce6",
  null
  
)

export default component.exports